import RavelloService from '@/services/ravello'

export const Bookings = {
	name: 'Bookings',
	route: 'studeo-bookings',
}

export const Booking = {
	name: 'Booking',
	route: 'studeo-booking',
	params: ['booking'],
	lazyName: {
		fn: async (booking) => {
			const found = await RavelloService.get(`/v2/bookings/${booking}`)
			return { name: found.studeo_id || `Booking for ${found.unit_code}` }
		},
		params: ['booking'],
		field: ['name'],
	},
}

export const BookingPayments = {
	name: 'Booking Payments',
	route: 'studeo-booking-payments',
}

export const BookingPayment = {
	name: 'Booking Payment',
	route: 'studeo-booking-payment',
	params: ['booking_payment'],
	lazyName: {
		fn: async (bookingPayment) => {
			const foundPayment = await RavelloService.get(`/v2/bookingpayments/${bookingPayment}`)
			const foundBooking = await RavelloService.get(`/v2/bookings/${foundPayment.booking}`)
			return { name: foundBooking.studeo_id || `Booking for ${foundBooking.unit_code}` }
		},
		params: ['booking_payment'],
		field: ['name'],
	},
}

export const ConvergeIdentities = {
	name: 'Converge Identities',
	route: 'converge-identities',
}

export const ConvergeIdentity = {
	name: 'New identity',
	route: 'converge-identity',
	params: ['identity'],
	lazyName: {
		fn: async identity => (identity === 'new' ? null : RavelloService.get(`/v2/converge/${identity}`)),
		params: ['identity'],
		field: 'name',
	},
}

export const Enterprises = {
	name: 'Enterprises',
	route: 'studeo-enterprises',
}

export const Enterprise = {
	name: 'New enterprise',
	route: 'studeo-enterprise',
	params: ['enterprise'],
	lazyName: {
		fn: async enterprise => (enterprise === 'new' ? null
			: RavelloService.get(`/v2/enterprises/${enterprise}`)),
		params: ['enterprise'],
		field: 'name',
	},
}

export const Amenities = {
	name: 'Amenities',
	route: 'studeo-amenities',
}

export const Features = {
	name: 'Features',
	route: 'studeo-features',
}

export const Integrations = {
	name: 'Integrations',
	route: 'integrations',
}

export const Integration = {
	name: 'Integration',
	route: 'integration',
	params: ['integration'],
	lazyName: {
		fn: async integration => RavelloService.get(`/v2/integrations/${integration}`),
		params: ['integration'],
		field: 'name',
	},
}

export const IntegrationCommission = {
	name: 'New commission',
	route: 'integration-commission',
	params: ['integration', 'connection', 'commission'],
	lazyName: {
		fn: async (integration, connection, commission) => (commission === 'new'
			? null
			: RavelloService.get(`/v2/integrations/${integration}/connections/${connection}/commissions/${commission}`)
		),
		params: ['integration', 'connection', 'commission'],
		field: 'source',
	},
}

export const IntegrationConnection = {
	name: 'New connection',
	route: 'integration-connection',
	params: ['integration', 'connection'],
	lazyName: {
		fn: async (integration, connection) => (connection === 'new'
			? null
			: RavelloService.get(`/v2/integrations/${integration}/connections/${connection}`)
		),
		params: ['integration', 'connection'],
		field: 'name',
	},
}

export const IntegrationConnectionTab = {
	name: 'Commissions',
	route: 'integration-connection-child',
	params: ['integration', 'connection', 'connectiontab'],
	lazyName: {
		fn: (connectiontab) => {
			switch (connectiontab) {
			case 'commissions':
				return { name: 'Commissions' }
			case 'overrides':
				return { name: 'Channel Overrides' }
			default:
				return { name: 'Not found' }
			}
		},
		params: ['connectiontab'],
		field: 'name',
	},
}

export const IntegrationsLogs = {
	name: 'Integrations Logs',
	route: 'integrations-logs',
}

export const IntegrationStatus = {
	name: 'Integrations Status',
	route: 'integrations-status',
}

export const PriceLabsStatus = {
	name: 'PriceLabs Status',
	route: 'pricelabs-status',
}

export const IntegrationProfile = {
	name: 'New profile',
	route: 'integration-profile',
	params: ['integration', 'profile'],
	lazyName: {
		fn: async (integration, profile) => (profile === 'new'
			? null
			: RavelloService.get(`/v2/integrations/${integration}/profiles/${profile}`)
		),
		params: ['integration', 'profile'],
		field: 'name',
	},
}

export const IntegrationTab = {
	name: 'Tab',
	route: 'integration-child',
	params: ['integration', 'tab'],
	lazyName: {
		fn: (tab) => {
			switch (tab) {
			case 'channels':
				return { name: 'Channels' }
			case 'profiles':
				return { name: 'Connection profiles' }
			case 'connections':
				return { name: 'Connections' }
			case 'mapping':
				return { name: 'Mapping' }
			case 'logs':
				return { name: 'Logs' }
			default:
				return { name: 'Not found' }
			}
		},
		params: ['tab'],
		field: 'name',
	},
}

export const Leads = {
	name: 'Website Leads',
	route: 'studeo-leads',
}

export const Resorts = {
	name: 'Resorts',
	route: 'studeo-resorts',
}

export const Resort = {
	name: 'Resort',
	route: 'studeo-resort',
	params: ['resort'],
	lazyName: {
		fn: async resort => RavelloService.get(`/v2/resorts/${resort}`),
		params: ['resort'],
		field: 'name',
	},
}

export const ResortComplex = {
	name: 'Complex',
	route: 'studeo-resort-complex',
	params: ['resort', 'complex'],
	lazyName: {
		fn: async (resort, complex) => RavelloService.get(`/v2/resorts/${resort}/complexes/${complex}`),
		params: ['resort', 'complex'],
		field: 'name',
	},
}

export const ResortComplexTab = {
	name: 'Complex',
	route: 'studeo-resort-complex-child',
	params: ['resort', 'complex', 'ctab'],
	lazyName: {
		fn: (ctab) => {
			switch (ctab) {
			case 'features':
				return { name: 'Features' }
			case 'channels':
				return { name: 'Channels' }
			default:
				return { name: 'Not found' }
			}
		},
		params: ['ctab'],
		field: 'name',
	},
}

export const ResortTab = {
	name: 'Tab',
	route: 'studeo-resort-child',
	params: ['resort', 'tab'],
	lazyName: {
		fn: (tab) => {
			switch (tab) {
			case 'areas':
				return { name: 'Areas' }
			case 'channels':
				return { name: 'Channels' }
			case 'complexes':
				return { name: 'Complexes' }
			case 'locations':
				return { name: 'Locations' }
			case 'reservations':
				return { name: 'Reservations' }
			case 'travelagents':
				return { name: 'Travel Agents' }
			case 'units':
				return { name: 'Units' }
			default:
				return { name: 'Not found' }
			}
		},
		params: ['tab'],
		field: 'name',
	},
}

export const ResortUnit = {
	name: 'Unit',
	route: 'studeo-resort-unit',
	params: ['resort', 'unit'],
	lazyName: {
		fn: async (resort, unit) => RavelloService.get(`/v2/resorts/${resort}/units/${unit}`),
		params: ['resort', 'unit'],
		field: 'code',
	},
}

export const ResortUnitTab = {
	name: 'Unit',
	route: 'studeo-resort-unit-child',
	params: ['resort', 'unit', 'utab'],
	lazyName: {
		fn: (utab) => {
			switch (utab) {
			case 'features':
				return { name: 'Features' }
			case 'availabilities':
				return { name: 'Availabilities' }
			case 'channels':
				return { name: 'Channels' }
			case 'amenities':
				return { name: 'Amenities' }
			default:
				return { name: 'Not found' }
			}
		},
		params: ['utab'],
		field: 'name',
	},
}

export const Reviews = {
	name: 'Reviews',
	route: 'studeo-reviews',
}

export const Review = {
	name: 'Review',
	route: 'studeo-review',
	params: ['review'],
	lazyName: {
		fn: async (review) => {
			const found = await RavelloService.get(`/v2/reviews/${review}`)
			return { name: found.external_confirmation_id }
		},
		params: ['review'],
		field: ['name'],
	},
}
